import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ISSUES_GROUP } from '../../constants/api';
import { Tab } from './Tab';
export function resolveFilterGroupType(hiddenType, type) {
    if (!hiddenType || ISSUES_GROUP.ALL === hiddenType) {
        return ISSUES_GROUP.ALL;
    }
    const typeToHide = type ?? hiddenType;
    return typeToHide === ISSUES_GROUP.ERRORS ? ISSUES_GROUP.WARNINGS : ISSUES_GROUP.ERRORS;
}
export const Tabs = (props) => {
    const { commitHash, locationPathname, hiddenType, filterByNewIssues, errorCount, warningCount, onClick } = props;
    const group = resolveFilterGroupType(hiddenType);
    return _jsx("ul", { className: "nav nav-tabs nav-fill", id: "mostCommonIssuesTab", role: "tablist", children: Object.values(ISSUES_GROUP).map((issueType) => {
            const postfix = issueType !== ISSUES_GROUP.ALL ? '/' + issueType : '';
            const tabUrl = `${locationPathname.split(commitHash)[0]}${commitHash}${postfix}`;
            return _jsx(Tab, { issueType: issueType, group: group !== ISSUES_GROUP.ALL ? group : '', tabUrl: tabUrl, warningCount: warningCount, errorCount: errorCount, filterByNewIssues: filterByNewIssues, onClick: () => onClick(issueType) }, issueType);
        }) });
};
